"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryQueue = void 0;
const queuePushResult_1 = require("./queuePushResult");
const utils_1 = require("../resilience/utils");
/**
 * A memory queue.
 */
class MemoryQueue {
    /**
     * Initializes a new instance of the @see MemoryQueue class.
     * @param maxLength The maximum length for the queue.
     * @param logger The logger to use.
     */
    constructor(maxLength, logger) {
        this.maxLength = maxLength;
        this.logger = logger;
        this.items = [];
    }
    /**
     * Gets the current length of the queue.
     * @returns The current length of the queue.
     */
    length() {
        this.logger.trace(null, `Getting length from MemoryQueue.`, null, utils_1.logFormatter);
        return this.items.length;
    }
    /**
     * Adds a new item to the beginning of the queue.
     * @param value The item to add at the beginning of thequeue.
     * @param requestId Request Guid.
     * @returns An object describing whether a pop was required to add the item to the queue.
     */
    push(value, requestId) {
        this.logger.trace(requestId, `Pushing '${value}' to MemoryQueue.`, null, utils_1.logFormatter);
        let hasPoped = false;
        let popedItem = null;
        if (this.items.length >= this.maxLength) {
            hasPoped = true;
            popedItem = this.pop(requestId);
            this.logger.information(requestId, `MemoryQueue reached size limit of '${this.maxLength}', poped '${popedItem}' to push '${value}'.`, null, utils_1.logFormatter);
        }
        this.items.push(value);
        this.logger.debug(requestId, `Pushed value '${value}' to MemoryQueue.`, null, utils_1.logFormatter);
        this.logger.debug(requestId, `New size of MemoryQueue: ${this.items.length}/${this.maxLength}`, null, utils_1.logFormatter);
        return new queuePushResult_1.QueuePushResult(hasPoped, popedItem);
    }
    /**
     * Removes the last item from the queue.
     * @param requestId Request Guid.
     * @returns The removed item of undefined.
     */
    pop(requestId) {
        this.logger.trace(requestId, `Poping from MemoryQueue.`, null, utils_1.logFormatter);
        const result = this.items.shift();
        this.logger.debug(requestId, `Poped value '${result}' from MemoryQueue.`, null, utils_1.logFormatter);
        return result;
    }
    /**
     * Excplicitly removes one item from the queue.
     * @param value Item to remove.
     * @param requestId Request Guid.
     * @return Result of remove operation.
     */
    remove(value, requestId) {
        this.logger.trace(requestId, `Explicitly removing '${value}' from MemoryQueue.`, null, utils_1.logFormatter);
        const index = this.items.indexOf(value, 0);
        if (index > -1) {
            this.items.splice(index, 1);
            this.logger.debug(requestId, `Explicitly removed value '${value}' from MemoryQueue.`, null, utils_1.logFormatter);
            return new queuePushResult_1.QueuePushResult(true, value);
        }
        return new queuePushResult_1.QueuePushResult(false, undefined);
    }
    /**
     * Clears the queue.
     */
    clear() {
        this.logger.warning(null, 'Maintenance: MemoryQueue cleared.', null, utils_1.logFormatter);
        this.items.length = 0;
    }
}
exports.MemoryQueue = MemoryQueue;
//# sourceMappingURL=memoryQueue.js.map